<template>
  <div class="skeleton-card">
        <div class="skeleton avatar"></div>
        <div class="skeleton-content">
            <div class="skeleton line short"></div>
            <div class="skeleton line"></div>
            <div class="skeleton line"></div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .skeleton-card {
        display: flex;
        align-items: center;
        background: white;
        padding: 16px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        .skeleton {
            background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
            background-size: 200% 100%;
            animation: shimmer 1.5s infinite linear;
            &.avatar {
                width: 100%;
                height: 70px;
                max-width: 70px;
                border-radius: 50%;
            }
            &.line {
                height: 12px;
                border-radius: 4px;
                width: 100%;
                &.short {
                    width: 60%;
                }
            }
        }

        .skeleton-content {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding-left: 10px;
            width: 100%;
        }
    }
    @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
    }
</style>